module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-counter"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        _vm.doCount(-1)
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": function($event) {
        _vm.doCount(1)
      }
    }
  }, [_vm._v("+")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2190d3bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/public-lib/vue-components/src/components/c-counter/index.vue
// module id = 355
// module chunks = 0